import { Coordinates, Incident, MapIncident } from "@/types/incidents";
import { createSlice } from "@reduxjs/toolkit";

export interface IncidentsState {
  incidents: Incident[];
  mapIncidents: MapIncident[];
  isLoading: boolean;
  error: string | null;
  subscriptionStatus: "connecting" | "connected" | "error" | null;
  casePositions:Coordinates[];
  seletedTrackingId:number | null;
  selectedIncident:MapIncident | null;
  selectedIncidentGroupID:string;
  isDisabledZoomed:boolean
}

const initialState: IncidentsState = {
  incidents: [],
  mapIncidents: [],
  isLoading: false,
  error: null,
  subscriptionStatus: null,
  casePositions:[],
  seletedTrackingId:null,
  selectedIncident:null,
  selectedIncidentGroupID:"",
  isDisabledZoomed:false
};



const incidentsSlice = createSlice({
  name: "incidents",
  initialState,
  reducers: {
    setCasePositions: (state: IncidentsState, action) => {
        if(action.payload)
        state.casePositions =[...state.casePositions,action.payload]; 
        else
        state.casePositions=[]
    },
    setSelectedTrackingId:(state:IncidentsState,action)=>{
        state.seletedTrackingId=action.payload
    },
    setSelectedIncident:(state:IncidentsState,action)=>{
        state.selectedIncident=action.payload;
    },
    setSelectedIncidentGroupId:(state:IncidentsState,action)=>{
        state.selectedIncidentGroupID=action.payload
    },
    setDisabledZoomed:(state:IncidentsState,action)=>{
      state.isDisabledZoomed=action.payload
    },
    resetIncidentState:(state:IncidentsState)=>{
      state.incidents=[];
      state.mapIncidents=[];
      state.casePositions=[];
      state.seletedTrackingId=null;
      state.selectedIncident=null;
      state.selectedIncidentGroupID=""
      state.isDisabledZoomed=false
    }
  },

});

export const { setCasePositions,setSelectedTrackingId,setSelectedIncident,setSelectedIncidentGroupId,setDisabledZoomed,resetIncidentState } =
  incidentsSlice.actions;
export default incidentsSlice.reducer;
